export default "__VITE_ASSET__Dn9m1Gl$__"